var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
import { getDate, getTime } from './datetime';
import { getMetar } from './metar';
import { getTaf } from './taf';
import { getWeather } from './weather';
/**
 * Determines whether the DOM contains an element with an ID.
 * @param id - The ID.
 * @returns Whether the DOM contains the element.
 */
export function containsElementWithId(id) {
    return ($('#' + id).length > 0);
}
/**
 * Creates a "note" element for a demo video.
 * @returns The note element.
 */
export function createDemoNote() {
    return $('<div></div>').attr('id', 'iss-feed-note').text('[Prerecorded]');
}
/**
 * Creates a `video` element for a demo video.
 * @param source - The video source.
 * @returns The video element.
 */
export function createDemoVideo(source) {
    const video = $('<video></video>').attr('id', 'iss-feed-demo').attr('autoplay', '').attr('loop', '').attr('muted', '').attr('src', source);
    video[0].autoplay = true;
    video[0].loop = true;
    video[0].muted = true;
    return video;
}
/**
 * Creates a forecast table row for a forecast period.
 * @param period - The forecast period.
 * @returns The row element.
 */
export function createForecastTableRow(period) {
    const row = $('<tr></tr>');
    const cell1 = $('<td></td>');
    const img = $('<img>').attr('src', period.iconUrl);
    cell1.append(img);
    const cell2 = $('<td></td>');
    const span = $('<span></span>').text(period.name + ':').addClass('forecast-period-name');
    cell2.append(span, (' ' + period.forecast));
    return row.append(cell1, cell2);
}
/**
 * Creates an `iframe` element for a live feed.
 * @param source - The live feed source.
 * @returns The iframe element.
 */
export function createLiveFeedIframe(source) {
    return $('<iframe></iframe>').attr('id', 'iss-live-feed').attr('title', 'ISS Live Feed').attr('allow', 'autoplay').attr('src', source);
}
/**
 * Retrieves the configuration from a config file.
 * @param configName The configuration file name.
 * @returns The configuration.
 */
export function getConfiguration(configName) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield $.get(`/api/configuration/${configName}`).promise();
        return JSON.parse(res);
    });
}
/**
 * Refreshes an iframe by reassigning its source.
 * @param id - The ID of the iframe element.
 */
export function refreshIframe(id) {
    const iframe = $(_normalizeId(id))[0];
    /* eslint-disable no-self-assign */
    iframe.src = iframe.src;
}
/**
 * Sets the current date on a page.
 * @param id - The ID of the destination element.
 */
export function setDate(id) {
    $(_normalizeId(id)).html(getDate());
}
/**
 * Sets the most recent METAR data from a station on a page.
 * @param id - The ID of the destination element.
 * @param stationId - The ID of the station.
 */
export function setMetar(id, stationId = 'KGFK') {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield getMetar(stationId);
        const $el = $(_normalizeId(id));
        if (data) {
            $el.html(data);
        }
        else {
            $el.html(_noData);
        }
    });
}
/**
 * Sets the most recent TAF data from a station on a page.
 * @param id - The ID of the destination element.
 * @param stationId - The ID of the station.
 */
export function setTaf(id, stationId = 'KGFK') {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield getTaf(stationId);
        const $el = $(_normalizeId(id));
        if (data) {
            $el.html(data);
        }
        else {
            $el.html(_noData);
        }
    });
}
/**
 * Sets the current time on a page.
 * @param id - The ID of the destination element.
 */
export function setTime(id) {
    $(_normalizeId(id)).html(getTime());
}
/**
 * Sets the most recent weather data on a page.
 * @param summaryId - The ID of the destination summary element.
 * @param detailsId - The ID of the destination details element.
 * @param stationId - The ID of the weather station.
 */
export function setWeather(summaryId, detailsId, stationId = 'KGFK') {
    return __awaiter(this, void 0, void 0, function* () {
        const currentWeather = yield getWeather(stationId);
        const $summaryEl = $(_normalizeId(summaryId));
        const $detailsEl = $(_normalizeId(detailsId));
        if (currentWeather) {
            $summaryEl.html(currentWeather.summary);
            $detailsEl.html(currentWeather.details).show();
        }
        else {
            $summaryEl.html(_noData);
            $detailsEl.hide();
        }
    });
}
const _noData = '**no data**';
/**
 * Normalizes a CSS ID selector by prepending the `#` if necessary.
 * @param id - The ID selector.
 * @returns The normalized ID selector.
 */
function _normalizeId(id) {
    if (id[0] !== '#') {
        id = `#${id}`;
    }
    return id;
}
